module.exports = __webpack_public_path__ + "img/export_to_dropbox.e3c3df83.svg";